import { Component, OnInit } from '@angular/core';
import { NewsServiceService } from '../../news-service.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  constructor(public NewsServiceService: NewsServiceService) { }

  ngOnInit(): void {
  }

}
